@if (filterSelectionOptions() && filterSelectionOptions()?.length) {
    @if (filterService.viewType === FilterViewTypeEnum.Summary) {
        <pill-group-pds3
            cg3-theme="PDS-v3"
            (visiblePillsChange)="onVisiblePillsChange($event)"
            groupId="pill-group-active-filters"
            [srLabelledBy]="headingId()"
            [initLinesCount]="linesCount()"
            [isExpanded]="isExpanded()"
        >
            <sr-only-pds3 flowClass="pill-group-heading-sr" *headingPds3>
                <h3 [attr.id]="headingId()" flow-id="pill-group-heading">Active filters</h3>
            </sr-only-pds3>

            <ng-container *ngTemplateOutlet="filterPills" />

            <pill-suggestion-field-pds3 *pillMoreButtonPds3 size="small">
                @if (morePillsCount() > 0) {
                    <button
                        (click)="onExpandButtonToggle()"
                        type="button"
                        flow-id="pill-group-more-button"
                        aria-controls="pill-group-active-filters"
                        [attr.aria-expanded]="isExpanded()"
                    >
                        @if (isExpanded()) {
                            {{ "FiltersSidebar.Actions.ShowLess" | translate }}
                        }
                        @if (!isExpanded()) {
                            {{ "+" + morePillsCount + " " + ("FiltersSidebar.Actions.ShowMore" | translate) }}
                        }
                    </button>
                }
            </pill-suggestion-field-pds3>
        </pill-group-pds3>
    } @else {
        <ng-container *ngTemplateOutlet="filterPills" />
    }
}

<ng-template #filterPills>
    @for (sel of filterSelectionOptions(); track sel) {
        <pill-dismissible-field-pds3 *pillItemPds3 size="small">
            <button (click)="onClose(sel.value)" type="button">
                <sr-only-pds3>Remove</sr-only-pds3> {{ sel.label | wkTranslate }}
                <icon-pds3 name="wk-icon-filled-close" />
            </button>
        </pill-dismissible-field-pds3>
    }
</ng-template>
